module.exports = __webpack_public_path__ + "img/crash.d88cdfc9.png";